import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Protected = ({ isAdmin, role, children, isCheckingPermission = false }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [lastCheckedRole, setLastCheckedRole] = useState('');

  useEffect(() => {
    // Clear any redirect blockers when component unmounts
    return () => {
      sessionStorage.removeItem(`auth_redirect_${role}`);
    };
  }, [role]);

  useEffect(() => {
    // ถ้า App.tsx ยังคงตรวจสอบ permission อยู่ ให้รอต่อไป
    if (isCheckingPermission) {
      setIsChecking(true);
      return;
    }
    
    // Only perform this check when the role changes or permission check complete
    if (role !== lastCheckedRole) {
      setLastCheckedRole(role);
    }
    
    setIsChecking(false);
  }, [isAdmin, role, lastCheckedRole, isCheckingPermission]);

  // แสดง loading ขณะตรวจสอบ
  if (isChecking || isCheckingPermission) {
    return (
      <div className="layout-loading">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  // Check if isAdmin is truthy before accessing properties
  if (!isAdmin) {
    // Clear any previous auth path tracking before redirecting
    sessionStorage.removeItem(`auth_redirect_${role}`);
    
    return <Navigate to={`/auth/${role}`} replace />;
  }
  return children;
};

export default Protected;
